// extracted by mini-css-extract-plugin
module.exports = {"slider":"ProductSliderBlock_slider__s2HU6","productSlider":"ProductSliderBlock_productSlider__tqwu_"};